import transformerMouvementClient from '@/services/mouvementClient/filter/mouvementClientServerTableDataTransformer';
import transform from '@/services/mouvementClient/echeanceAPayerSurFactureServerTableDataTransformer';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/MouvementClient/';

export async function getByRemiseBancaire(id) {
  const response = await HTTP.get(URL_BASE + 'GetByRemiseBancaireAsync', { params: { id } });
  return response;
}

export async function getSolde(param) {
  const response = await HTTP.get(URL_BASE + 'GetSoldeAsync', { params: { tiersId: param.tiersId, date: param.date } });
  return response;
}
export async function getAll(MouvementClientFilter) {
  const inputServer = transformerMouvementClient(MouvementClientFilter);
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', inputServer);
  return response;
}

export async function getAllJournal(MouvementClientFilter) {
  const inputServer = transformerMouvementClient(MouvementClientFilter);
  const response = await HTTP.post(URL_BASE + 'PGetAllJournalAsync', inputServer);
  return response;
}

export async function getAllByPiece(MouvementClientFilter) {
  const inputServer = transformerMouvementClient(MouvementClientFilter);
  const response = await HTTP.post(URL_BASE + 'PGetPiecesAPayerAsync', inputServer);
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function updateAllReferencePaiement(param) {
  const response = await HTTP.put(URL_BASE + 'UpdateReferenceReglementMouvementClient', param);
  return response;
}

export async function getEcheanceAPayerAsync(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetEcheancesAPayerAsync', inputServer);
  return response;
}

export async function echeanceAPayerUpdateSurFacture(param) {
  const response = await HTTP.post(URL_BASE + 'EcheancierAPayerUpdateAsync', param);
  return response;
}

export async function getCumulEcheanceAPayer(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetCumulEcheanceAPayerAsync', inputServer);
  return response;
}

export async function annulerPaiementsAsync(guids, nature, motifId, dateComptable) {
  const response = await HTTP.post(URL_BASE + 'PAnnulerPaiementsAsync',
    {
      mouvementClientPaiementIds: guids,
      nature: nature,
      motifId: motifId,
      dateComptable: dateComptable,
    });
  return response;
}
